import { db, delay } from "./api";

export const warehouseService = {
  async getWarehouses() {
    await delay(200);
    return [...db.warehouses];
  },

  async getWarehouseById(id) {
    await delay(150);
    return db.warehouses.find((w) => w.id === id) || null;
  },

  async getStockTransfers() {
    await delay(200);
    return [...db.stockTransfers];
  },

  async createStockTransfer(data) {
    await delay(350);
    const newTransfer = {
      ...data,
      id: `TRF-${Date.now()}`,
      transferCode: `TRF/WH${data.fromLocationId.slice(-1)}-WH${data.toLocationId.slice(-1)}/${Math.floor(1000 + Math.random() * 9000)}`,
      status: "In Transit",
      date: data.date || new Date().toISOString().slice(0, 10),
      productCount: data.items.length,
      totalUnits: data.items.reduce((sum, item) => sum + Number(item.qty), 0)
    };

    // Deduct stock from origin warehouse batches
    data.items.forEach((item) => {
      let qtyToDeduct = Number(item.qty);
      for (const batch of db.batches) {
        if (batch.productId === item.productId && batch.warehouseId === data.fromLocationId && batch.qtyRemaining > 0) {
          const deduct = Math.min(batch.qtyRemaining, qtyToDeduct);
          batch.qtyRemaining -= deduct;
          qtyToDeduct -= deduct;
          if (qtyToDeduct <= 0) break;
        }
      }
    });

    db.stockTransfers.unshift(newTransfer);

    db.auditLogs.unshift({
      id: `AUD-${Date.now()}`,
      user: data.responsiblePerson || "Logistics Dispatcher",
      role: "Warehouse Manager",
      action: "Initiated Stock Transfer",
      module: "Stock Transfer",
      timestamp: new Date().toISOString().replace("T", " ").slice(0, 19),
      details: `Created transfer ${newTransfer.transferCode} (${newTransfer.totalUnits} units) to ${data.toLocationName}`
    });

    db.persistAll();
    return newTransfer;
  },

  async completeStockTransfer(transferId) {
    await delay(300);
    const transfer = db.stockTransfers.find((t) => t.id === transferId);
    if (!transfer) throw new Error("Transfer not found");

    transfer.status = "Completed";

    // Add stock to destination warehouse
    transfer.items.forEach((item) => {
      const destBatch = db.batches.find((b) => b.productId === item.productId && b.warehouseId === transfer.toLocationId);
      if (destBatch) {
        destBatch.qtyRemaining += Number(item.qty);
      } else {
        const prod = db.products.find((p) => p.id === item.productId);
        db.batches.unshift({
          id: `BAT-${Date.now()}-${Math.floor(Math.random() * 100)}`,
          batchNo: `TRF-BAT-${Date.now().toString().slice(-4)}`,
          productId: item.productId,
          productName: item.productName || prod?.name,
          mfgDate: "2026-06-01",
          expiryDate: "2027-06-01",
          qtyRemaining: Number(item.qty),
          warehouseId: transfer.toLocationId,
          warehouseCode: transfer.toLocationId === "WH-001" ? "WH-BHIWANDI" : transfer.toLocationId === "WH-002" ? "WH-KURLA" : "WH-DADAR",
          binCode: "D-A1-B1",
          unitCost: prod?.purchasePrice || 100,
          mrp: prod?.MRP || 150,
          status: "Good"
        });
      }
    });

    db.auditLogs.unshift({
      id: `AUD-${Date.now()}`,
      user: "Destination Supervisor",
      role: "Warehouse Staff",
      action: "Completed Stock Transfer",
      module: "Stock Transfer",
      timestamp: new Date().toISOString().replace("T", " ").slice(0, 19),
      details: `Marked transfer ${transfer.transferCode} as Received & Completed at destination.`
    });

    db.persistAll();
    return transfer;
  }
};
